import {Size} from '@jetbrains/ring-ui/components/input/input'
import Select from '@jetbrains/ring-ui/components/select/select'
import {useState} from 'react'

import {
  getDraft,
  getOriginal,
} from '../../../../../../../../EditPipelinePage/EditPipelinePage.selectors'
import {pipelineDraft} from '../../../../../../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../../../../../../hooks/pipeline'
import Details from '../../../../../../Details/Details'
import EditSettingsForm from '../../../../../../EditSettingsForm/EditSettingsForm'
import {useBranchesArg} from '../../PipelineRepository.hooks'

import BranchInput from './BranchInput/BranchInput'

import styles from './BranchSettingsForm.css'

import {useAppDispatch, useAppSelector} from 'src/hooks/react-redux'
import {restApi} from 'src/services/rest'

const includedBranchesLabel = (
  <>
    {'Included'}
    <Details>{'A comma-separated list of branches'}</Details>
  </>
)
const excludedBranchesLabel = (
  <>
    {'Excluded'}
    <Details>{'A comma-separated list of branches'}</Details>
  </>
)

type Rules = {
  included: string
  excluded: string
}

type Props = Rules & {
  onClose: () => void
}
function BranchSettingsForm({included, excluded, onClose}: Props) {
  const id = usePipelineId()

  const savedDefaultBranch = useAppSelector(state => getOriginal(state, id)?.vcsRoot.branch ?? '')
  const defaultBranch = useAppSelector(state => getDraft(state, id)?.vcsRoot.branch ?? '')

  const branchesArg = useBranchesArg()
  const {branches} = restApi.endpoints.getAllBranches.useQuery(branchesArg, {
    selectFromResult: ({data}) => ({branches: data?.branch}),
  })

  const [defaultBranchDraft, setDefaultBranchDraft] = useState(defaultBranch)
  const [includedDraft, setIncludedDraft] = useState(included)
  const [excludedDraft, setExcludedDraft] = useState(excluded)

  const dispatch = useAppDispatch()

  const confirmHandler = () => {
    dispatch(pipelineDraft.actions.setDefaultBranch({id, branch: defaultBranchDraft}))
    dispatch(
      pipelineDraft.actions.setBranchSpec({
        id,
        branchSpecification: [
          ...(includedDraft.length > 0
            ? includedDraft.split(',').map(branch => `+:refs/heads/(${branch})`)
            : ['+:refs/heads/*']),
          ...(excludedDraft.length > 0
            ? excludedDraft.split(',').map(branch => `-:refs/heads/(${branch})`)
            : []),
        ].join('\n'),
      }),
    )
    onClose()
  }

  return (
    <EditSettingsForm onConfirmClick={confirmHandler} onCancelClick={onClose}>
      <Select
        size={Size.FULL}
        loading={branches == null}
        selectedLabel={'Default branch'}
        selected={{key: defaultBranchDraft, label: defaultBranchDraft}}
        data={branches?.map(item => {
          const name = (item.default ? savedDefaultBranch : item.name) ?? ''
          return {key: name, label: name}
        })}
        onSelect={item => item && setDefaultBranchDraft(item.label)}
        add={{prefix: 'Use branch'}}
        onAdd={setDefaultBranchDraft}
        filter
      />
      <BranchInput
        aria-label={'Included'}
        label={includedBranchesLabel}
        value={includedDraft}
        onChange={setIncludedDraft}
      />
      <div className={styles.notice}>
        {'Patterns with * are supported. Leave empty to include all branches.'}
      </div>
      <BranchInput
        aria-label={'Excluded'}
        label={excludedBranchesLabel}
        value={excludedDraft}
        onChange={setExcludedDraft}
      />
      <div className={styles.notice}>{'Patterns with * are supported.'}</div>
    </EditSettingsForm>
  )
}

export default BranchSettingsForm
